module.exports = __webpack_public_path__ + "img/logo-dark.d94aa895.svg";